import React from 'react';
import PropTypes from 'prop-types';
import { Box, Stack, Typography, Divider } from '@mui/material';
import { Styles } from 'pages/myidm/components/form-card/style';

const FormCard = ({ title, children, padding, margin, gap, showDivider }) => {
    return (
        <Box sx={Styles.formCard.paper} padding={padding}>
            {title && (
                <>
                    <Box sx={Styles.formCard.wrapper}>
                        <Typography sx={Styles.formCard.heading} variant="subtitle1">
                            <Stack direction="row">{title}</Stack>
                        </Typography>
                    </Box>
                    {showDivider && <Divider variant="middle" />}
                </>
            )}
            <Box display="flex" gap={gap} flexWrap="wrap" sx={{ ml: margin, mr: margin, mb: 0 }}>
                {children}
            </Box>
        </Box>
    );
};

FormCard.propTypes = {
    title: PropTypes.any,
    children: PropTypes.element,
    padding: PropTypes.any,
    margin: PropTypes.any,
    gap: PropTypes.any,
    showDivider: PropTypes?.bool,
};

FormCard.defaultProps = {
    title: undefined,
    children: <></>,
    padding: 0,
    margin: 0,
    gap: 4,
    showDivider: true,
};

export default React.memo(FormCard);
